<template>
  <div class="fatherBox">
    <!-- <GmapMap :center="center" :zoom="15" style="width: 100%; height: 100vh">
      <GmapMarker
        v-for="(m, index) in markers"
        :key="index"
        :position="m.position"
        :icon="m.icon"
      />
      <GmapPolyline :options="options" :path="arr" />
    </GmapMap> -->
    <div id="allmap"></div>
    <div class="view">
      <div class="clear ltineraryInfo">
        <div class="image fl">
          <van-image
            round
            width="1.2rem"
            fit="cover"
            height="1.2rem"
            :src="userInfo.avatar"
          />
        </div>
        <div class="fl text">
          <div>
            <h3>{{ userInfo.nickName }}</h3>
            <p class="time">{{ userInfo.startTime }}</p>
          </div>
        </div>
      </div>
      <nav class="clear">
        <div class="fl">
          <h4>{{ userInfo.totalMileage }}</h4>
          <p>{{ $18nText(1) }}</p>
        </div>
        <div class="fl">
          <h4>{{ timeFormat(userInfo.totalTime) }}</h4>
          <p>{{ $18nText(2) }}</p>
        </div>
        <div class="fl">
          <h4>{{ userInfo.avgSpeed || 0 }}</h4>
          <p>{{ $18nText(163) }}</p>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import { getPerTrackRecordDetail } from '@/api/stroke';
let map;
export default {
  data() {
    return {
      center: { lat: 22.54286, lng: 114.05956 }, // 地图中心位置
      arr: [
        // 描点集合 用于连线
      ],
      markers: [],
      options: {
        strokeColor: '#2680EB'
      },
      userInfo: {}
    };
  },
  activated() {
    this.firstList();
  },
  mounted() {
    // 百度地图API功能
    map = new BMapGL.Map('allmap'); // 创建Map实例
    map.centerAndZoom(new BMapGL.Point(116.404, 39.915), 15); // 初始化地图,设置中心点坐标和地图级别

    map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
  },
  methods: {
    firstList() {
      let { id } = this.$route.query;
      getPerTrackRecordDetail({ id }).then(res => {
        let newArr = [];
        let markers = [];
        res.data.trackInfos = res.data.trackInfos ? res.data.trackInfos : [];
        res.data.trackInfos.forEach((item, index) => {
          newArr.push(new BMapGL.Point(item.longitude, item.latitude));
          if (index == 0) {
            // this.center = {
            //   lat: item.latitude,
            //   lng: item.longitude
            // };
            let myIcon = new BMapGL.Icon(
              require('@/assets/origin.png'),
              new BMapGL.Size(18, 20)
            );
            map.centerAndZoom(
              new BMapGL.Point(item.longitude, item.latitude),
              15
            );
            map.addOverlay(
              new BMapGL.Marker(
                new BMapGL.Point(item.longitude, item.latitude),
                { icon: myIcon }
              )
            );
            // markers.push({
            //   position: { lat: item.latitude, lng: item.longitude },
            //   icon: require('@/assets/origin.png')
            // });
          } else if (index == res.data.trackInfos.length - 1) {
            // markers.push({
            //   position: { lat: item.latitude, lng: item.longitude },
            //   icon: require('@/assets/destination.png')
            // });
            let myIcon = new BMapGL.Icon(
              require('@/assets/destination.png'),
              new BMapGL.Size(18, 20)
            );
            map.addOverlay(
              new BMapGL.Marker(
                new BMapGL.Point(item.longitude, item.latitude),
                { icon: myIcon }
              )
            );
          }
        });
        // 绘制线
        var polyline = new BMapGL.Polyline(newArr, {
          strokeColor: '#2680EB',
          strokeWeight: 5
        });
        map.addOverlay(polyline);
        // this.arr = newArr;
        // this.markers = markers;
        this.userInfo = { ...res.data.userInfo, ...res.data.trackRecordInfo };
      });
    },
    timeFormat(time) {
      if (time === null || time == undefined) {
        return '';
      }
      return ((time / 60) >> 0) + 'h ' + (time % 60) + 'min';
    }
  }
};
</script>
<style lang="scss" scoped>
#allmap {
  width: 100%;
  height: 100vh;
}
.view {
  width: calc(100% - 1rem);
  height: 3rem;
  position: fixed;
  left: 0;
  bottom: 0;
  background: url('../../assets/card.png') no-repeat;
  background-size: 100% 100%;
  padding: 0.6rem 0.5rem 0;
  z-index: 999;
  .ltineraryInfo {
    .image {
      margin-right: 0.2rem;
      img {
        width: 1.2rem;
        height: 1.2rem;
        display: block;
        border-radius: 50%;
      }
    }
    .text {
      height: 1.2rem;
      display: flex;
      align-items: center;
      h3 {
        font-size: 0.42rem;
        font-weight: bold;
        line-height: 0.59rem;
        color: rgba(43, 47, 56, 1);
      }
      .time {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.43rem;
        color: rgba(43, 47, 56, 1);
      }
      margin-bottom: 0.3rem;
    }
  }
  nav {
    .fl {
      width: calc(100% / 3);
      text-align: center;
      position: relative;
      &:last-child {
        &:after {
          display: none;
        }
      }
      &:after {
        height: 0.5rem;
        border-right: 1px dashed #cccccc;
        content: '';
        display: block;
        position: absolute;
        right: 0;
        top: 0.16rem;
      }
    }
    h4 {
      font-size: 0.3rem;
      font-weight: 400;
      line-height: 0.52rem;
      color: rgba(43, 47, 56, 1);
    }
    p {
      font-size: 0.2rem;
      font-weight: 400;
      line-height: 0.28rem;
      color: rgba(43, 47, 56, 1);
    }
  }
}
</style>
